const URL_PATTERN = /(https?:\/\/[^\s<]+[^\s<.,;:!?)}\]"'])/gi;
const MARKDOWN_LINK_PATTERN = /\[([^\]]+)\]\(([^)]+)\)/g;

export const normalizeLinkUrl = (url) => {
  const trimmed = String(url || '').trim();
  if (!trimmed) return '';
  if (/^(https?:\/\/|mailto:|tel:)/i.test(trimmed)) return trimmed;
  if (/^\/\//.test(trimmed)) return `https:${trimmed}`;
  return `https://${trimmed}`;
};

const escapeHtml = (value) =>
  String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

export const enhanceHtmlLinks = (html) => {
  const trimmed = String(html || '').trim();
  if (!trimmed || typeof document === 'undefined') return trimmed;

  try {
    const container = document.createElement('div');
    container.innerHTML = trimmed;
    container.querySelectorAll('a[href]').forEach((anchor) => {
      const href = normalizeLinkUrl(anchor.getAttribute('href'));
      if (!href) return;
      anchor.setAttribute('href', href);
      anchor.setAttribute('target', '_blank');
      anchor.setAttribute('rel', 'noopener noreferrer');
    });
    return container.innerHTML;
  } catch {
    return trimmed;
  }
};

export const linkifyPlainText = (text) => {
  const raw = String(text || '');
  if (!raw) return '';

  const placeholders = [];
  let working = raw.replace(MARKDOWN_LINK_PATTERN, (match, label, url) => {
    const href = normalizeLinkUrl(url);
    const token = `@@MDLINK${placeholders.length}@@`;
    placeholders.push(
      `<a href="${escapeHtml(href)}" target="_blank" rel="noopener noreferrer">${escapeHtml(label)}</a>`
    );
    return token;
  });

  working = escapeHtml(working);
  placeholders.forEach((linkHtml, index) => {
    working = working.replace(`@@MDLINK${index}@@`, linkHtml);
  });

  working = working.replace(URL_PATTERN, (url) => {
    const href = normalizeLinkUrl(url);
    return `<a href="${escapeHtml(href)}" target="_blank" rel="noopener noreferrer">${escapeHtml(url)}</a>`;
  });

  return working;
};

export const plainTextToHtmlBody = (text) => {
  const raw = String(text || '').trim();
  if (!raw) return '';
  const lines = raw.split('\n').map((line) => linkifyPlainText(line));
  return `<div>${lines.join('<br>')}</div>`;
};

export const hasMarkdownLinks = (text) => MARKDOWN_LINK_PATTERN.test(String(text || ''));
